import { API_COUNTRY_CODE_MAP } from '@/shared/config/marketConfig'

// Add authentication token to every request
const normalizeCountryCode = value => {
  if (typeof value !== 'string') return ''
  return value.split(',')[0]?.trim()?.toUpperCase() || ''
}

const getConfiguredCountry = () => normalizeCountryCode(import.meta.env.VITE_COUNTRIES)

const getStoredCountry = () => {
  return normalizeCountryCode(sessionStorage.getItem('countryCode')) || normalizeCountryCode(localStorage.getItem('countryCode'))
}

const getDefaultCountry = isDev => {
  if (isDev) {
    return getConfiguredCountry() || getStoredCountry() || 'MX'
  }
  return getStoredCountry() || getConfiguredCountry()
}

export const authInterceptor = (config, options = {}) => {
  const isDev = options.isDev ?? import.meta.env.DEV
  const country = getDefaultCountry(isDev)
  const token = localStorage.getItem('msalAccessToken')
  config.headers = config.headers || {}

  if (country && !config.headers.countryCode) {
    // TODO: Remove API_COUNTRY_CODE_MAP lookup once all market backends are deployed.
    config.headers.countryCode = API_COUNTRY_CODE_MAP[country] ?? country
  }
  config.headers['Time-Zone'] = Intl.DateTimeFormat().resolvedOptions().timeZone
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
}

// Attach the interceptor to an Axios instance
export const attachAuthInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.request.use(authInterceptor, (error) =>
    Promise.reject(new Error(error))
  )
}
